module.exports = __webpack_public_path__ + "assets/img/fb0187cb2bb0dfa3bd2fd6f64655a294.png";